import { useState } from "react";
import Header3 from "../Header3";
import Footer3 from "../Footer3";
import PageBanner from "../PageBanner";
import bannerBg from '../../assets/img/page-banner.jpg'
import { isTokenValid, getPayload } from "../../helpers/jwt";
import { toast, ToastContainer } from "react-toastify"
import { useHistory } from "react-router-dom";
import InfoForm from "./RequestForm";


function RequestInfo() {


    return (
        <>
            
            <Header3 />
            <PageBanner bannerBg={bannerBg} heading="Request a Quote" currentPage="Request a Quote" />
            <InfoForm />
            <Footer3 />
        </>
    );
}

export default RequestInfo;
